import { ApolloError } from '@apollo/client';

import {
  GetCatalogProductViewQuery,
  CatalogVariantFragmentFragment,
} from '@notino/shared/definitions/types';
import { AdditionalServicesAvailability } from '@notino/web-tracking';

import { AttributeTypes, IEngraving } from './../../ProductListing/model';
import { BrandsId } from './model';

export const getModifaceAvailability = (
  hasModiface: boolean
): AdditionalServicesAvailability =>
  hasModiface
    ? AdditionalServicesAvailability.available
    : AdditionalServicesAvailability.notAvailable;

export const hasVirtualTryOn = (
  variant: Pick<CatalogVariantFragmentFragment, 'attributes'> | null | undefined
): boolean => Boolean(variant?.attributes?.[AttributeTypes.VirtualTryOn]);

type Product = NonNullable<
  GetCatalogProductViewQuery['productDetailByCatalogMasterId']
>;

export const getTryItFirstAvailability = (
  cartTryItFirstShow: boolean,
  tryItFirstCampaigns: Product['campaigns'],
  selectedVariant: CatalogVariantFragmentFragment,
  additionalServicesError: ApolloError | undefined
) => {
  if (additionalServicesError) {
    return AdditionalServicesAvailability.timeout;
  }

  if (!cartTryItFirstShow) {
    return AdditionalServicesAvailability.hidden;
  }

  if (
    tryItFirstCampaigns!.some(
      (tryItFirstCampaign) =>
        tryItFirstCampaign!.productId === selectedVariant.webId
    )
  ) {
    return AdditionalServicesAvailability.available;
  }

  return AdditionalServicesAvailability.notAvailable;
};

export const getEngravingAvailability = (
  cartEngravingShow: boolean,
  engraving: IEngraving | undefined | null,
  additionalServicesError: ApolloError | undefined
): AdditionalServicesAvailability => {
  if (additionalServicesError) {
    return AdditionalServicesAvailability.timeout;
  }

  if (engraving?.allowed) {
    return cartEngravingShow && engraving.config.isAvailable
      ? AdditionalServicesAvailability.available
      : AdditionalServicesAvailability.hidden;
  }

  return AdditionalServicesAvailability.notAvailable;
};

export const getVariantDescription = (variant, product): string =>
  variant.attributes && variant.attributes.Master
    ? product.annotation
    : variant.variantName;

export const isDiorBrand = (brandId: string | null | undefined) =>
  brandId === BrandsId.DIOR;

export const getVariantName = (
  variant: Partial<
    Pick<Product['variants'][number], 'additionalInfo' | 'parameters'>
  >
) => {
  if (variant.additionalInfo) {
    return variant.additionalInfo;
  }

  if (variant.parameters?.package) {
    return `${variant.parameters.package} ${
      variant.parameters?.unit || ''
    }`.trim();
  }

  return null;
};
